import NotificationListPage from './NotificationListPage';

export default NotificationListPage;
